
export const STATE_DETAIL = 'detail';
export const STATE_EDIT = 'edit';
export const DATA_STATE_INITIALIZING = 'initializing';
export const DATA_STATE_INITIALIZED = 'initialized';
export const BACK_END = '后台';
export const MIDDLE_END = '中台';
export const ATTACHMENT = 'annex';
export const I18N = false; // 是否开启多语言支持



//////////////////
// WEBPACK FOOTER
// ./config/CONST.js
// module id = A1P4
// module chunks = 105